import { handleError } from './apiUtils'
import { getConfigurationAsync, xKMSClient } from './httpMethods'
import { LocalAccessKeysApi, UnlockPinRequestDto } from './kmsapiclient'

/**
 * Retrieves the unlock pin based on the provided request.
 *
 * @param request - The request object containing the unlock pin.
 * @returns A promise that resolves to the unlock pin.
 */
export async function getUnlockPinAsync(
  request: UnlockPinRequestDto,
): Promise<string> {
  try {
    const localAccessKeysApi = new LocalAccessKeysApi(getConfigurationAsync())
    const response = (
      await localAccessKeysApi.enrollmentKeyGetPin(xKMSClient, request)
    ).data
    return response
  } catch (error) {
    handleError(error)
    return Promise.reject(error)
  }
}
